<template>
  <div class="title">
    <div class="t-left">
      <div class="l-top">
        <p class="text">{{ title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'template.textTitle',
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
    };
  },
  watch: {},
  methods: {},
  mounted() { },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "YouSheBiaoTiHei";
  src: url("../../assets/fonts/YouSheBiaoTiHei.woff2");
}

.title {
  width: 435px;
  height: 40px;
}

.t-left {
  .l-top {
    width: 435px;
    height: 37.5px;
    background: url('../../assets/template/title.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 2px 0 0 40px;

    .text {
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: 20px;
      color: #FFFFFF;
    }
  }
}
</style>